import { CriteoIntegration } from "./_criteoApi";
import { CriteoFlagship } from "./_flagship";

export class CriteoProductPage extends CriteoIntegration {
  #carousel;
  #selectors = {
    container: "#criteo-owl-carousel",
    carousel: "#criteo-owl",
  };

  #generateParams() {
    const [variant, price, compareAt, available] =
      this.#carousel.dataset.product.split(",");

    return {
      item: variant,
      price: price / 100,
      "list-price": (compareAt > 0 ? compareAt : price) / 100,
      availability: available === "true" ? 1 : 0,
    };
  }

  async exec() {
    if (!this._isActive) return;
    if (this._isMarketingBlocked()) return;

    this.#carousel = document.querySelector(this.#selectors.carousel);

    const response = await this._baseRequest("viewItem", {
      ...this.#generateParams(),
    });

    // Flagship — reuse same response to avoid duplicate API call
    const flagship = new CriteoFlagship(false);
    flagship.setResponse(response);
    flagship.exec("products");

    const { placements } = response;

    if (!placements.length) {
      document.querySelector(this.#selectors.container).style.display = "none";
      return;
    }

    const device = screen.width <= 750 ? "Mobile" : "Desktop";

    const [
      {
        [`viewItemApi${device}-MidCarousel`]: [
          { products, OnViewBeacon, OnLoadBeacon },
        ],
      },
    ] = placements;

    return await this._renderCarousel(products, OnViewBeacon, OnLoadBeacon);
  }
}
